function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
function nextTick(func) {
    setTimeout(func, 0);
}
function resolver() {
    let resolveReady;
    const ready = new Promise((resolve) => {
        resolveReady = resolve;
    });
    return [ready, resolveReady];
}
export { sleep, nextTick, resolver };
